import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

declare var $:any;

@Component({
  selector: 'app-error-404-2',
  templateUrl: './error-404-2.component.html',
})
export class Error4042Component implements OnInit, AfterViewInit, OnDestroy {

  constructor(
    public _router: Router
  ) {
    localStorage.clear();
    sessionStorage.clear();
    this._router.navigate(['/login']);
  }

  ngOnInit() {
    $('body').addClass('empty-layout');
  }

  ngAfterViewInit() { }

  ngOnDestroy() {
    $('body').removeClass('empty-layout');
  }

}



// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/error-404-2/error-404-2.component.ts